import { render } from "./part.vue?vue&type=template&id=7a601c7d&ts=true"
import script from "./part.vue?vue&type=script&lang=ts"
export * from "./part.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"client/components/MessageTypes/part.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7a601c7d"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7a601c7d', __exports__)) {
    api.reload('7a601c7d', __exports__)
  }
  
  module.hot.accept("./part.vue?vue&type=template&id=7a601c7d&ts=true", () => {
    api.rerender('7a601c7d', render)
  })

}


export default __exports__